export const changePageMeta = (route, from, next) => {
  if(route.meta.title) {
    document.title = route.meta.title;
  }
}